import React from 'react';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {
    Layout, Menu, Breadcrumb, Icon,Card,
  } from 'antd';
import '../../assets/css/App.css';
import routes from '../../model/router';
import Header1 from '../public';

const {
    Header, Content, Footer, Sider,
  } = Layout;
const SubMenu = Menu.SubMenu;
const { Meta } = Card;

const tabListNoTitle = [{
  key: 'Publications',
  tab: 'Publications',
}, {
  key: 'Introduction',
  tab: 'Introduction',
}, {
  key: 'Programs',
  tab: 'Programs',
}];

  
  const contentListNoTitle = {
    Publications: 
    <p>
      <div>Journal articles:</div>
    <div>Nan Xu*, et al. and Jiangdian Song*. Predicting Invasiveness of Lung Adenocarcinoma from Chest CT with Few-shot Vision-Language Ternary Classification Model. <txt style={{fontWeight:'bold'}}>NPJ Digital Medicine,</txt> 2025, 101988.</div>
    <div>Yuqiang Mao*, et al. and Jiangdian Song*. Assessments of lung nodules by an artificial intelligence chatbot using longitudinal CT images. <txt style={{fontWeight:'bold'}}>Cell Reports Medicine,</txt> 2025, 6(3), 101988.</div>
    <div>Lu Wang*, et al. and Jiangdian Song*. Role of artificial intelligence in medical image analysis. <txt style={{fontWeight:'bold'}}>Chinese Medical Journal,</txt> 2025,  138 (22), 2879-2894.</div>
    <div>Lu Wang*, et al. and Jiangdian Song*. A general approach for automatic segmentation of pneumonia, pulmonary nodule, and tuberculosis in CT images. <txt style={{fontWeight:'bold'}}>iScience,</txt> 2023, 26(7), 107005.</div>
    <div>Kexue Deng*, et al. and Jiangdian Song*. A deep learning-based system for survival benefit prediction of tyrosine kinase inhibitors and immune checkpoint inhibitors in stage IV non-small cell lung cancer patients: A multicenter, prognostic study. <txt style={{fontWeight:'bold'}}>eClinicalMedicine,</txt> 2022, 51, 101541.</div>
    <div>Jiangdian Song, et al. Automatic Lung Nodule Segmentation and Intra-Nodular Heterogeneity Image Generation. <txt style={{fontWeight:'bold'}}>IEEE Journal of Biomedical and Health Informatics,</txt> 2022, 26 (6), 2570-2581.</div>
    <div>Lu Wang, et al. and Jiangdian Song*. Trends in the application of deep learning networks in medical image analysis: Evolution between 2012 and 2020. <txt style={{fontWeight:'bold'}}>European Journal of Radiology,</txt> 2022, 146, 110069.</div>
    <div>Hongmei Wang, et al. and Jiangdian Song*. Decoding COVID-19 pneumonia: comparison of deep learning and radiomics CT image signatures. <txt style={{fontWeight:'bold'}}>European Journal of Nuclear Medicine and Molecular Imaging,</txt> 2021, 48(5):1478-1486.</div>
    <div>Lu Wang, et al. and Jiangdian Song*. Multi-classifier-based identification of COVID-19 from chest computed tomography using generalizable and interpretable radiomics features. <txt style={{fontWeight:'bold'}}>European Journal of Radiology,</txt> 2021;136:109552.</div>
    <div>Jiangdian Song*, et al. Development and validation of a machine learning model to explore tyrosine kinase inhibitors response in patients with stage IV EGFR variant-positive non-small cell lung cancer. <txt style={{fontWeight:'bold'}}>JAMA Network Open,</txt> 2020, 2(12): e2030442.</div>
    <div>Jiangdian Song, et al. End-to-end automatic differentiation of the coronavirus disease 2019 (COVID-19) from viral pneumonia based on chest CT. <txt style={{fontWeight:'bold'}}>European Journal of Nuclear Medicine and Molecular Imaging,</txt> 2020, 47(11), 2516-2524.</div>
    <div>Lu Wang, et al. and Jiangdian Song*. Decoding and Systematization of Medical Imaging Features of Multiple Human Malignancies. <txt style={{fontWeight:'bold'}}>Radiology: Imaging Cancer,</txt> 2020, 2(5): e190079. </div>
    <div>Jiangdian Song*, et al. A review of original articles published in the emerging field of radiomics. <txt style={{fontWeight:'bold'}}>European Journal of Radiology,</txt> 2020, 127:108991.</div>
    <div>Jiangdian Song, et al. Development and validation of a prognostic index for efficacy evaluation and prognosis of first-line chemotherapy in local advanced lung squamous cell carcinoma. <txt style={{fontWeight:'bold'}}>European Radiology,</txt> 2019;29(5):2388-2398.</div>
    <div>Jiangdian Song, et al. A New Approach to Predict Progression-free Survival in Stage IV EGFR-mutant NSCLC Patients with EGFR-TKI Therapy. <txt style={{fontWeight:'bold'}}>Clinical cancer research,</txt> 2018;24(15):3583-3592.</div>
    <div>Jiangdian Song, et al. Lung Lesion Extraction Using a Toboggan Based Growing Automatic Segmentation Approach. <txt style={{fontWeight:'bold'}}>IEEE transactions on medical imaging,</txt> 2016;35(1):337-353.</div>
    <br></br>
    <div>Conference articles:</div>
    <div>Jiangdian Song, et al. The 111th Scientific Assembly and Annual Meeting of the Radiological Society of North America (RSNA). McCormick Place, Chicago, 2025-11-30 to 2025-12-4.</div>
    <div>Jiangdian Song, et al. Artificial Intelligence Chatbot for Lung Nodule Feature Characterization and Lung Cancer Probability Estimation from Chest CT Images: A Multi-center Retrospective Study. The Lancet Summit: cancer control in China. February 21-23, 2025, Shanghai, China.</div>
    <div>Jiangdian Song, et al. A general approach for automatic segmentation for pneumonia plumonary nodule and tuberculosis on CT images. presented at the 108th Int. Conf. Radiological Society of North America (RSNA), Chicago, Chicago, November 27 - December 01, 2022.</div>
    <div>Jiangdian Song, et al. A hybrid loss-based network architecture for end-to-end lung nodule segmentation. presented at the 107th Int. Conf. Radiological Society of North America (RSNA), Chicago, Illinois, November 28 - December 02, 2021.</div>
    <div>Jiangdian Song, et al. Development and validation of a radiomics nomogram for progression-free survival prediction in stage IV EGFR-mutant non-small cell lung cancer. presented at the Int. Conf. International Society for Optics and Photonics (SPIE), 101343R, 2017.</div>
    <div>Jiangdian Song, et al. Prognostic Value of CT Phenotype in Stage IV EGFR-Mutation-Positive Non-Small Cell Lung Cancer Undering Tyrosine Kinase Inhibitors. presented at the 102nd Int. Conf. Radiological Society of North America (RSNA), Chicago, Illinois, November 27 - December 02, 2016. Student Travel Award.</div>
    <div>Jiangdian Song, et al. Association between tumor heterogeneity and overall survival in patients with non-small cell lung cancer. presented at the 2016 International Symposium on Biomedical Imaging (ISBI), IEEE, 1249-1252, 2016.</div>
    <div>Jiangdian Song, et al. Association between Tumor Heterogeneity and Progression-free Survival in Non-small Cell Lung Cancer Patients with EGFR Mutations Undergoing Tyrosine Kinase Inhibitors Therapy. The 38th Annual International Conference of the IEEE Engineering in Medicine and Biology Society (EMBC), 1268 - 1271, 2016.</div>
    <div>Jiangdian Song, et al. A New Quantitative Radiomics Approach for Non-Small Cell Lung Cancer (NSCLC) Prognosis. presented at the 101st Int. Conf. Radiological Society of North America (RSNA), Chicago, Illinois, November 29 - December 04, 2015.</div>
    </p>,
    Introduction: <p><div>Dr. Song completed his doctoral study at the Key Laboratory of Molecular Imaging, Institute of Automation, Chinese Academy of Sciences and Northeastern University in 2017, and finished his postdoctoral research at China Medical University (2017-2019).</div> 
                      <div>As a visiting scholar, he conducted AI-based medical image analysis research at Lucas Center, Department of Radiology, Stanford University School of Medicine from 2019 to 2020.</div>
                      <div>He is now an associate professor at China Medical University, and his main research direction is medical artificial intelligence and medical image analysis.</div>
                  </p>,
    Programs: 
    <p>
        <div>National Natural Science Foundation of China (Grant No. 82001904 and No. 92259104)</div>
        <div>The 63rd batch of first-class grants from China Post-doctoral Science Foundation (2018M630310)</div>
       
    </p>,
  };
  

class Director extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          key: 'tab1',
          noTitleKey: 'Introduction',
        };
    }
  
    onTabChange = (key, type) => {
        console.log(key, type);
        this.setState({ [type]: key });
      }
    render() {
        return (
          <div>
            <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{ background: '#fff' }}>
                <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['1']}
                    defaultOpenKeys={['sub1']}
                    style={{ height: '100%' }}
                  >
                      <SubMenu key="sub1" title={<span><Icon type="user" />Staff</span>}>
                      <Menu.Item key="1"><Link to="/director">Director</Link></Menu.Item>
                      <Menu.Item key="2"><Link to="/member">Member</Link></Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub2" title={<span><Icon type="user" />Students</span>}>
                      <Menu.Item key="3"><Link to="/graduates">Graduates</Link></Menu.Item>
                      <Menu.Item key="4"><Link to="/intern-doctors">Intern doctors</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>


                <img src={require('../../assets/images/jds.jpg')} style={{paddingLeft:350, height: 350}} />
                 
                <txt style={{fontSize:20,fontWeight:"bold", paddingLeft:50}}><br></br><br></br><br></br>Dr. Jiangdian Song <br></br>

                Associate Professor<br></br>
                
                Research Direction: Medical image analysis<br></br>
                Email: song.jd0910@gmail.com</txt><br></br>
                      

                <div className="card1">
                <Card
                tabList={tabListNoTitle}
                activeTabKey={this.state.noTitleKey}
                onTabChange={(key) => { this.onTabChange(key, 'noTitleKey'); }}
                >
                {contentListNoTitle[this.state.noTitleKey]}
                </Card>
                </div>

            </Layout>
          </Content>
          </div>
        )
    }
}
export default Director;